import { createWebHistory, createRouter } from "vue-router";

import EcommercePage from "../pages/Dashboard/EcommercePage.vue";
import LMSCoursesPage from "../pages/Dashboard/LMSCoursesPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import ForgotPasswordPage from "../pages/Authentication/ForgotPasswordPage.vue";
import ResetPasswordPage from "../pages/Authentication/ResetPasswordPage.vue";
import EmailConfirmationPage from "../pages/Authentication/EmailConfirmationPage.vue";
import ErrorPage from "../pages/ErrorPage.vue";

import MaintenancePage from "../pages/PagesInner/MaintenancePage.vue";
import ConnectedAccountsPage from "../pages/PagesInner/ConnectedAccountsPage.vue";
import LogoutPage from "../pages/LogoutPage.vue";
import ListePermissionPage from "@/pages/Permission/ListePermissionPage.vue";
import AddRolePage from "@/pages/Role/AddRolePage.vue";
import EditRolePage from "@/pages/Role/EditRolePage.vue";
import ListeRolePage from "@/pages/Role/ListeRolePage.vue";
import ViewRolePage from "@/pages/Role/ViewRolePage.vue";
import AddUserPage from "@/pages/Users/AddUserPage.vue";
import EditUserPage from "@/pages/Users/EditUserPage.vue";
import ListeUserPage from "@/pages/Users/ListeUserPage.vue";
import ProfilePage from "../pages/PagesInner/ProfilePage.vue";
import AddCategorieArticlePage from "@/pages/CategorieArticle/AddCategorieArticlePage.vue";
import EditCategorieArticlePage from "@/pages/CategorieArticle/EditCategorieArticlePage.vue";
import ListeCategorieArticlePage from "@/pages/CategorieArticle/ListeCategorieArticlePage.vue";
import ViewCategorieArticlePage from "@/pages/CategorieArticle/ViewCategorieArticlePage.vue";
import ListeCategorieFaqPage from "@/pages/CategorieFaq/ListeCategorieFaqPage.vue";
import ListeFaqTagPage from "@/pages/FaqTag/ListeFaqTagPage.vue";
import ListeCategorieInfoPage from "@/pages/CategorieInfo/ListeCategorieInfoPage.vue";
import ListeTypeMediaPage from "@/pages/TypeMedia/ListeTypeMediaPage.vue";
import ListeParametrePage from "@/pages/Parametre/ListeParametrePage.vue";
import ListeCollectionPage from "@/pages/Collection/ListeCollectionPage.vue";
import ViewCollectionPage from "@/pages/Collection/ViewCollectionPage.vue";
import ListeIntervallePoidsPage from "@/pages/IntervallePoids/ListeIntervallePoidsPage.vue";
import AddDistancePage from "@/pages/Distance/AddDistancePage.vue";
import EditDistancePage from "@/pages/Distance/EditDistancePage.vue";
import ListeDistancePage from "@/pages/Distance/ListeDistancePage.vue";
import AddMediaPage from "@/pages/Media/AddMediaPage.vue";
import EditMediaPage from "@/pages/Media/EditMediaPage.vue";
import ListeMediaPage from "@/pages/Media/ListeMediaPage.vue";
import AddArticlePage from "@/pages/Article/AddArticlePage.vue";
import EditArticlePage from "@/pages/Article/EditArticlePage.vue";
import ListeArticlePage from "@/pages/Article/ListeArticlePage.vue";
import ViewArticlePage from "@/pages/Article/ViewArticlePage.vue";
import AddMontantPage from "@/pages/Montant/AddMontantPage.vue";
import EditMontantPage from "@/pages/Montant/EditMontantPage.vue";
import ListeMontantPage from "@/pages/Montant/ListeMontantPage.vue";
import AddFaqPage from "@/pages/Faq/AddFaqPage.vue";
import EditFaqPage from "@/pages/Faq/EditFaqPage.vue";
import ListeFaqPage from "@/pages/Faq/ListeFaqPage.vue";
import ViewFaqPage from "@/pages/Faq/ViewFaqPage.vue";
import ListeTagPage from "@/pages/Tag/ListeTagPage.vue";
import AddAproposPage from "@/pages/Apropos/AddAproposPage.vue";
import EditAproposPage from "@/pages/Apropos/EditAproposPage.vue";
import ViewAproposPage from "@/pages/Apropos/ViewAproposPage.vue";
import ListeAproposPage from "@/pages/Apropos/ListeAproposPage.vue";
import AddInfoFooterPage from "@/pages/InfoFooter/AddInfoFooterPage.vue";
import EditInfoFooterPage from "@/pages/InfoFooter/EditInfoFooterPage.vue";
import ViewInfoFooterPage from "@/pages/InfoFooter/ViewInfoFooterPage.vue";
import ListeInfoFooterPage from "@/pages/InfoFooter/ListeInfoFooterPage.vue";
import AddContactPage from "@/pages/Contact/AddContactPage.vue";
import EditContactPage from "@/pages/Contact/EditContactPage.vue";
import ViewContactPage from "@/pages/Contact/ViewContactPage.vue";
import ListeContactPage from "@/pages/Contact/ListeContactPage.vue";
import AddCompositionPage from "@/pages/Composition/AddCompositionPage.vue";
import EditCompositionPage from "@/pages/Composition/EditCompositionPage.vue";
import ListeCompositionPage from "@/pages/Composition/ListeCompositionPage.vue";
import ViewCompositionPage from "@/pages/Composition/ViewComposition.vue";
import ListeAvisTalentPage from "@/pages/AvisTalents/ListeAvisTalentPage.vue";
import StatistiquesSignalementsPage from "@/pages/AvisTalents/StatistiquesSignalementsPage.vue";

import AddAlaUnePage from "@/pages/AlaUne/AddAlaUnePage.vue";
import EditAlaUnePage from "@/pages/AlaUne/EditAlaUnePage.vue";
import ListeAlaUnePage from "@/pages/AlaUne/ListeAlaUnePage.vue";
import ViewAlaUnePage from "@/pages/AlaUne/ViewAlaUnePage.vue";
import ListeAvisPage from "@/pages/Avis/ListeAvisPage.vue";



import ListeAnneeAcademiquePage from "@/pages/AnnneeAcademique/ListeAnneeAcademiquePage.vue";
import ListeNiveauPage from "@/pages/Niveau/ListeNiveauPage.vue";
import ListeFilierePage from "@/pages/Filiere/ListeFilierePage.vue";
import ListeMatierePage from "@/pages/Matiere/ListeMatierePage.vue";



import { useAuthStore } from "@/services/auth";
import ApiService from "@/services/ApiService";
import ListeForumPage from "@/pages/Forum/ListeForumPage.vue";
import ListeTypeEmploiDuTempsPage from "@/pages/TypeEmploiDuTemps/ListeTypeEmploiDuTempsPage.vue";
import ListeClassePage from "@/pages/Classe/ListeClassePage.vue";
import ListeQualificationPage from "@/pages/Qualification/ListeQualificationPage.vue";
import ListeActivitePage from "@/pages/Activite/ListeActivitePage.vue";
import ListeLanguePage from "@/pages/Langue/ListeLanguePage.vue";
import ListeCategorieOffrePage from "@/pages/CategorieOffre/ListeCategorieOffrePage.vue";
import ViewProfesseurPage from "@/pages/Professeur/ViewProfesseurPage.vue";
import ListeProfesseurPage from "@/pages/Professeur/ListeProfesseurPage.vue";
import EditProfesseurPage from "@/pages/Professeur/EditProfesseurPage.vue";
import AddProfesseurPage from "@/pages/Professeur/AddProfesseurPage.vue";
import AddSupportPage from "@/pages/Support/AddSupportPage.vue";
import EditSupportPage from "@/pages/Support/EditSupportPage.vue";
import ListeSupportPage from "@/pages/Support/ListeSupportPage.vue";
import ViewSupportPage from "@/pages/Support/ViewSupportPage.vue";
import ListePropositionReponsePage from "@/pages/PropositionReponse/ListePropositionReponsePage.vue";
import AddPropositionReponsePage from "@/pages/PropositionReponse/AddPropositionReponsePage.vue";
import EditPropositionReponsePage from "@/pages/PropositionReponse/EditPropositionReponsePage.vue";
import ViewPropositionReponsePage from "@/pages/PropositionReponse/ViewPropositionReponsePage.vue";
import ListeQuestionPage from "@/pages/Question/ListeQuestionPage.vue";
import AddQuestionPage from "@/pages/Question/AddQuestionPage.vue";
import EditQuestionPage from "@/pages/Question/EditQuestionPage.vue";
import ViewQuestionPage from "@/pages/Question/ViewQuestionPage.vue";
import AddFiliereNiveauMatierePage from "@/pages/FiliereNiveauMatiere/AddFiliereNiveauMatierePage.vue";
import EditFiliereNiveauMatierePage from "@/pages/FiliereNiveauMatiere/EditFiliereNiveauMatierePage.vue";
import ListeFiliereNiveauMatierePage from "@/pages/FiliereNiveauMatiere/ListeFiliereNiveauMatierePage.vue";
import AddEmploiPage from '@/pages/EmploiDuTemps/AddEmploiPage.vue';
import EditEmploiPage from '@/pages/EmploiDuTemps/EditEmploiPage.vue';
import ListeEmploiPage from '@/pages/EmploiDuTemps/ListeEmploiPage.vue';
import ViewEmploiPage from '@/pages/EmploiDuTemps/ViewEmploiPage.vue';
import AddOffrePage from "@/pages/Offre/AddOffrePage.vue";
import EditOffrePage from "@/pages/Offre/EditOffrePage.vue";
import ListeOffrePage from "@/pages/Offre/ListeOffrePage.vue";
import ViewOffrePage from "@/pages/Offre/ViewOffrePage.vue";
import ListeTypePiecePage from "@/pages/TypePiece/ListeTypePiecePage.vue";
import EditInscriptionPage from "@/pages/Inscription/EditInscriptionPage.vue";
import ListeInscriptionPage from "@/pages/Inscription/ListeInscriptionPage.vue";
import ViewInscriptionPage from "@/pages/Inscription/ViewInscriptionPage.vue";
import AddInscriptionPage from "@/pages/Inscription/AddInscriptionPage.vue";
import TestPage from "@/pages/Test/TestPage.vue";
import FaireTestPage from "@/pages/Session/FaireTestPage.vue";
import ListeSessionPage from "@/pages/Session/ListeSessionPage.vue";
import ListeParentPage from "@/pages/Parent/ListeParentPage.vue";
import EditParentPage from "@/pages/Parent/EditParentPage.vue";
import AddParentPage from "@/pages/Parent/AddParentPage.vue";
import ViewParentPage from "@/pages/Parent/ViewParentPage.vue";
import CandidatureOffrePage from "@/pages/Offre/CandidatureOffrePage.vue";
import AvisOffrePage from "@/pages/Offre/AvisOffrePage.vue";
import CandidaterDetails from "@/components/Offre/CandidaterDetails.vue";
import EditSessionPage from "@/pages/Session/EditSessionPage.vue";
import ViewSessionPage from "@/pages/Session/ViewSessionPage.vue";
import ContinuerSessionPage from "@/pages/Session/ContinuerSessionPage.vue";
import ReprendreSessionPage from "@/pages/Session/ReprendreSessionPage.vue";
import ViewSessionReponsePage from "@/pages/Session/ViewSessionReponsePage.vue";
import AddQuestionQCMPage from "@/pages/Question/AddQuestionQCMPage.vue";
import FaireTestQCMPage from "@/pages/Support/FaireTestQCMPage.vue";


import SubmitDevoirPage from "@/pages/Devoir/SubmitDevoirPage.vue";
import ListeDevoirsPage from "@/pages/Devoir/ListeDevoirsPage.vue";
import MesDevoirsPage from "@/pages/Devoir/MesDevoirsPage.vue";
import ViewDevoirPage from "@/pages/Devoir/ViewDevoirPage.vue";
import EditDevoirPage from "@/pages/Devoir/EditDevoirPage.vue";

import ViewDemandeInscriptionPage from "@/pages/DemandeInscription/ViewDemandeInscriptionPage.vue";
import ListeDemandeInscriptionPage from "@/pages/DemandeInscription/ListeDemandeInscriptionPage.vue";
import TraiterDemandeInscriptionPage from "@/pages/DemandeInscription/TraiterDemandeInscriptionPage.vue";
import ViewEtudiantPage from "@/pages/Etudiant/ViewEtudiantPage.vue";
import ListeEtudiantPage from "@/pages/Etudiant/ListeEtudiantPage.vue";
import EditEtudiantPage from "@/pages/Etudiant/EditEtudiantPage.vue";
import AddEtudiantPage from "@/pages/Etudiant/AddEtudiantPage.vue";
import PreviewCompositionPage from "@/pages/Composition/PreviewCompositionPage.vue";
import MonAgendaPage from "@/pages/Agenda/MonAgendaPage.vue";
import AddPublication from "@/pages/Publication/AddPublication.vue";
import AddPublicationPage from "@/pages/Publication/AddPublicationPage.vue";
import ListPublicationPage from "@/pages/Publication/ListPublicationPage.vue";
import EditPublicationPage from "@/pages/Publication/EditPublicationPage.vue";
import AddSupportCoursPage from "@/pages/Support/AddSupportCoursPage.vue";
import DetailsCompositionPage from "@/pages/Composition/DetailsCompositionPage.vue";
import CompositionQuizPage from "@/pages/Composition/CompositionQuizPage.vue";
import ResultatCompositionPage from "@/pages/Composition/ResultatCompositionPage.vue";
import SessionsACorrigerPage from "@/pages/Composition/SessionsACorrigerPage.vue";
import CorrectionSessionPage from "@/pages/Composition/CorrectionSessionPage.vue";



const routes = [
  

  {
    path: "/",
    redirect: "/login",
    component: () => import("@/layouts/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
      path: "/AjoutPublication",
      name: "AddPublication",
      component:AddPublicationPage
      },
      {
          path: "/listPublication",
          name: "ListPublication",
          component:ListPublicationPage
      },
      {
          path: "/editPublication/:id",
          name: "EditPublication",
          component:EditPublicationPage
      },
      {
        path: '/sessions-a-corriger',
        name: 'SessionsACorrigerPage',
        component:SessionsACorrigerPage
      },
      {
        path: '/correction-session/:sessionId',
        name: 'CorrectionSessionPage',
        component: CorrectionSessionPage
      },

      {
        path: "/tableau_bord",
        name: "tableauBordPage",
        component: EcommercePage,
      },
      {
        path: "/tableau_bord1",
        name: "tableauBordPage1",
        component: LMSCoursesPage,
      },

      //**Début gestion des contenus */
      {
        path: "/ajouter-categorieArticle",
        name: "AddCategorieArticlePage",
        component: AddCategorieArticlePage,
      },
      {
        path: "/modifier-categorieArticle/:id",
        name: "EditCategorieArticlePage",
        component: EditCategorieArticlePage,
      },
      {
        path: "/liste-categorieArticles",
        name: "ListeCategorieArticlePage",
        component: ListeCategorieArticlePage,
      },
      {
        path: "/view-categorieArticle/:id",
        name: "ViewCategorieArticlePage",
        component: ViewCategorieArticlePage,
      },
      {
        path: "/liste-categorieInfos",
        name: "ListeCategorieInfoPage",
        component: ListeCategorieInfoPage,
      },
      {
        path: "/liste-categoriefaqs",
        name: "ListeCategorieFaqPage",
        component: ListeCategorieFaqPage,
      },
      {
        path: "/liste-faqTags",
        name: "ListeFaqTagPage",
        component: ListeFaqTagPage,
      },
      {
        path: "/liste-typeMedias",
        name: "ListeTypeMediaPage",
        component: ListeTypeMediaPage,
      },
      {
        path: "/liste-typePieces",
        name: "ListeTypePiecePage",
        component: ListeTypePiecePage,
      },
      {
        path: "/liste-parametres",
        name: "ListeParametrePage",
        component: ListeParametrePage,
      },

      {
        path: "/liste-collections",
        name: "ListeCollectionPage",
        component: ListeCollectionPage,
      },
      {
        path: "/view-collection/:id",
        name: "ViewCollectionPage",
        component: ViewCollectionPage,
      },
      {
        path: "/liste-intervallePoids",
        name: "ListeIntervallePoidsPage",
        component: ListeIntervallePoidsPage,
      },
      {
        path: "/liste-tags",
        name: "ListeTagPage",
        component: ListeTagPage,
      },
      {
        path: "/ajouter-distance",
        name: "AddDistancePage",
        component: AddDistancePage,
      },
      {
        path: "/modifier-distance/:id",
        name: "EditDistancePage",
        component: EditDistancePage,
      },
      {
        path: "/liste-distances",
        name: "ListeDistancePage",
        component: ListeDistancePage,
      },
      {
        path: "/ajouter-media",
        name: "AddMediaPage",
        component: AddMediaPage,
      },
      {
        path: "/modifier-media/:id",
        name: "EditMediaPage",
        component: EditMediaPage,
      },
      {
        path: "/liste-medias",
        name: "ListeMediaPage",
        component: ListeMediaPage,
      },
      {
        path: "/ajouter-article",
        name: "AddArticlePage",
        component: AddArticlePage,
      },
      {
        path: "/modifier-article/:id",
        name: "EditArticlePage",
        component: EditArticlePage,
      },
      {
        path: "/liste-articles",
        name: "ListeArticlePage",
        component: ListeArticlePage,
      },
      {
        path: "/view-article/:id",
        name: "ViewArticlePage",
        component: ViewArticlePage,
      },

      //path composition

      {
        path: "/ajouter-composition",
        name: "AddCompositionPage",
        component: AddCompositionPage,
      },

      {
        path: "/modifier-composition/:id",
        name: "EditCompositionPage",
        component: EditCompositionPage,
      },

      {
        path: "/liste-compositions",
        name: "ListeCompositionPage",
        component: ListeCompositionPage,
      },

      {
        path: "/view-composition/:id",
        name: "ViewCompositionPage",
        component: ViewCompositionPage,
      },
      {
        path: "/details-composition/:id",
        name: "DetailsCompositionPage",
        component: DetailsCompositionPage,
      },
      {
        path: "/resultat-Composition/:id",
        name: "ResultatCompositionPage",
        component: ResultatCompositionPage,
      },
      {
        path: "/compositionquiz/:id",
        name: "ComposerQuizPage",
        component: CompositionQuizPage,
      },

      {
        path: "/preview-composition/:id",
        name: "PreviewCompositionPage",
        component: PreviewCompositionPage,
        meta: {
          requiresAuth: true,
          roles: ["ADMIN", "SUPER_ADMIN", "Superadmin", "PROFESSEUR"]
        }
      },

      
      //path avis talents

      {
        path: "/liste-avistalents",
        name: "ListeAvisTalentPage",
        component: ListeAvisTalentPage,
      },

      {
        path: "/stat-avistalents",
        name: "StatistiquesSignalements",
        component: StatistiquesSignalementsPage,
      },


      //path support

      {
        path: "/ajouter-support",
        name: "AddSupportPage",
        component: AddSupportPage,
      },

      {
        path: "/modifier-support/:id",
        name: "EditSupportPage",
        component: EditSupportPage,
      },

      {
        path: "/liste-support",
        name: "ListeSupportPage",
        component: ListeSupportPage,
      },
      {
        path: '/support/:id/medias',
        name: 'AddSupportCours',
        component: AddSupportCoursPage
      },

      {
        path: "/view-support/:id",
        name: "ViewSupportPage",
        component: ViewSupportPage,
      },


        //path devoirs

      {
        path: "/soumettre-devoir",
        name: "SubmitDevoirPage",
        component: SubmitDevoirPage,
      },


      {
        path: "/liste-devoirs",
        name: "ListeDevoirsPage",
        component: ListeDevoirsPage,
      },

       {
        path: "/mes-devoirs",
        name: "MesDevoirspage",
        component: MesDevoirsPage,
      },

      {
          path: "/modifier-devoir/:id",
        name: "EditDevoirPage",
        component: EditDevoirPage,
      },

      {
        path: "/devoirs/:id",
        name: "ViewDevoirPage",
        component: ViewDevoirPage,
      },

      {
        path: "/ajouter-faq",
        name: "AddFaqPage",
        component: AddFaqPage,
      },
      {
        path: "/modifier-faq/:id",
        name: "EditFaqPage",
        component: EditFaqPage,
      },
      {
        path: "/liste-faqs",
        name: "ListeFaqPage",
        component: ListeFaqPage,
      },
      {
        path: "/view-faq/:id",
        name: "ViewFaqPage",
        component: ViewFaqPage,
      },
      {
        path: "/ajouter-montant",
        name: "AddMontantPage",
        component: AddMontantPage,
      },
      {
        path: "/modifier-montant/:id",
        name: "EditMontantPage",
        component: EditMontantPage,
      },
      {
        path: "/liste-montants",
        name: "ListeMontantPage",
        component: ListeMontantPage,
      },
      {
        path: "/ajouter-apropos",
        name: "AddAproposPage",
        component: AddAproposPage,
      },
      {
        path: "/modifier-apropos/:id",
        name: "EditAproposPage",
        component: EditAproposPage,
      },
      {
        path: "/view-apropos/:id",
        name: "ViewAproposPage",
        component: ViewAproposPage,
      },
      {
        path: "/liste-apropos",
        name: "ListeAproposPage",
        component: ListeAproposPage,
      },

      {
        path: "/ajouter-infoFooter",
        name: "AddInfoFooterPage",
        component: AddInfoFooterPage,
      },
      {
        path: "/modifier-infoFooter/:id",
        name: "EditInfoFooterPage",
        component: EditInfoFooterPage,
      },
      {
        path: "/view-infoFooter/:id",
        name: "ViewInfoFooterPage",
        component: ViewInfoFooterPage,
      },
      {
        path: "/liste-infoFooter",
        name: "ListeInfoFooterPage",
        component: ListeInfoFooterPage,
      },
      {
        path: "/liste-avis",
        name: "ListeAvisPage",
        component: ListeAvisPage,
      },
      {
        path: "/ajouter-alaUne",
        name: "AddAlaUnePage",
        component: AddAlaUnePage,
      },
      {
        path: "/modifier-alaUne/:id",
        name: "EditAlaUnePage",
        component: EditAlaUnePage,
      },
      {
        path: "/liste-alaUnes",
        name: "ListeAlaUnePage",
        component: ListeAlaUnePage,
      },
      {
        path: "/view-alaUne/:id",
        name: "ViewAlaUnePage",
        component: ViewAlaUnePage,
      },
      {
        path: "/ajouter-contact",
        name: "AddContactPage",
        component: AddContactPage,
      },
      {
        path: "/modifier-contact/:id",
        name: "EditContactPage",
        component: EditContactPage,
      },
      {
        path: "/view-contact/:id",
        name: "ViewContactPage",
        component: ViewContactPage,
      },
      {
        path: "/liste-contacts",
        name: "ListeContactPage",
        component: ListeContactPage,
      },

      //** FIn gestion des contenus */
      {
        path: '/test',
        name: 'TestPage',
        component: TestPage,
      },

      {
        path: '/liste-propositions',
        name: 'ListePropositionPage',
        component: ListePropositionReponsePage,
      },
      {
        path: '/ajouter-proposition',
        name: 'AddPropositionPage',
        component: AddPropositionReponsePage,
      },
      {
        path: '/modifier-proposition/:id',
        name: 'EditPropositionPage',
        component: EditPropositionReponsePage,
      },


      {
        path: '/voir-proposition/:id',
        name: 'ViewPropositionPage',
        component: ViewPropositionReponsePage,
      },

      {
        path: '/liste-questions',
        name: 'ListeQuestionPage',
        component: ListeQuestionPage,
      },
      {
        path: '/ajouter-question',
        name: 'AddQuestionPage',
        component: AddQuestionPage,
      },
      {
        path: '/ajouter-questionQCM',
        name: 'AddQuestionQCMPage',
        component: AddQuestionQCMPage,
      },

      {
        path: '/modifier-question/:id',
        name: 'EditQuestionPage',
        component: EditQuestionPage,
      },
      {
        path: '/voir-question/:id',
        name: 'ViewQuestionPage',
        component: ViewQuestionPage,
      },

      //** Gestion e-learning */
      {
        path: "/liste-matieres",
        name: "ListeMatierePage",
        component: ListeMatierePage,
      },
      {
        path: "/liste-filieres",
        name: "ListeFilierePage",
        component: ListeFilierePage,
      },
      {
        path: "/liste-niveaux",
        name: "ListeNiveauPage",
        component: ListeNiveauPage,

      },
      {
        path: "/liste-annees",
        name: "ListeAnneeAcademiquePage",
        component: ListeAnneeAcademiquePage,
      },
      {
        path: "/liste-forums",
        name: "ListeForumPage",
        component: ListeForumPage,
      },


      {
        path: "/ajouter-inscription",
        name: "AddInscriptionPage",
        component: AddInscriptionPage,
        meta: {
          title: 'Ajouter un document',
        }
      },
      {
        path: "/liste-inscriptions",
        name: "ListeInscriptionPage",
        component: ListeInscriptionPage,
        meta: {
          title: 'Liste des inscriptions',
        }
      },
      {
        path: "edit-inscription/:id",
        name: "EditInscriptionPage",
        component: EditInscriptionPage,
        meta: {
          title: 'Modifier une instruction',
        }
      },
       {
        path: "/view-inscription/:id",
        name: "ViewInscriptionPage",
        component: ViewInscriptionPage,
      },
      {
        path: "/view-inscription/:id",
        name: "ViewInscriptionPage",
        component: ViewInscriptionPage,
      },

       {
        path: "/liste-demande-inscriptions",
        name: "ListeDemandeInscriptionPage",
        component: ListeDemandeInscriptionPage,
        meta: {
          title: 'Liste des demandes d`\'inscriptions',
        }
      },
      {
        path: "/view-demande-inscription/:id",
        name: "ViewDemandeInscriptionPage",
        component: ViewDemandeInscriptionPage,
      },

       {
        path: "/manage-inscription/:id",
        name: "TraiterDemandeInscriptionPage",
        component: TraiterDemandeInscriptionPage,
      },


      //** Gestion solidarité */
      {
        path: "/ajouter-parent",
        name: "AddParentPage",
        component: AddParentPage,
      },
      {
        path: "/modifier-parent/:id",
        name: "EditParentPage",
        component: EditParentPage,
      },
      {
        path: "/liste-parents",
        name: "ListeParentPage",
        component: ListeParentPage,
      },
      {
        path: "/view-parent/:id",
        name: "ViewParentPage",
        component: ViewParentPage,
      },


      {
        path: "/liste-classes",
        name: "ListeClassePage",
        component: ListeClassePage,
      },
      {
        path: "/ajouter-professeur",
        name: "AddProfesseurPage",
        component: AddProfesseurPage,
      },
      {
        path: "/modifier-professeur/:id",
        name: "EditProfesseurPage",
        component: EditProfesseurPage,
      },
      {
        path: "/liste-professeurs",
        name: "ListeProfesseurPage",
        component: ListeProfesseurPage,
      },
      {
        path: "/view-professeur/:id",
        name: "ViewProfesseurPage",
        component: ViewProfesseurPage,
      },
 {
        path: "/ajouter-etudiant",
        name: "AddEtudiantPage",
        component: AddEtudiantPage,
      },
      {
        path: "/modifier-etudiant/:id",
        name: "EditEtudiantPage",
        component: EditEtudiantPage,
      },
      {
        path: "/liste-etudiants",
        name: "ListeEtudiantPage",
        component: ListeEtudiantPage,
      },
      {
        path: "/view-etudiant/:id",
        name: "ViewEtudiantPage",
        component: ViewEtudiantPage,
      },
      {
        path: "/ajouter-emploi",
        name: "AddEmploiPage",
        component: AddEmploiPage,
      },
      {
        path: "/modifier-emploi/:id",
        name: "EditEmploiPage",
        component: EditEmploiPage,

      },
      {
        path: "/liste-emplois",
        name: "ListeEmploiPage",
        component: ListeEmploiPage,
      },
      {
        path: "/view-emploi/:id",
        name: "ViewEmploiPage",
        component: ViewEmploiPage,
      },


      {
        path: "/mon-agenda",
        name: "MonAgendaPage",
        component: MonAgendaPage,
      },

      {
        path: "/ajouter-offre",
        name: "AddOffrePage",
        component: AddOffrePage,
      },
      {
        path: '/candidater/:id',
        name: 'CandidaterDetailsPage',
        component: CandidaterDetails,
      },

      {
        path: "/modifier-offre/:id",
        name: "EditOffrePage",
        component: EditOffrePage,
      },
      {
        path: "/liste-offres",
        name: "ListeOffrePage",
        component: ListeOffrePage,
      },
      {
        path: "/view-offre/:id",
        name: "ViewOffrePage",
        component: ViewOffrePage,
      },
      {
        path: "/offres/:id/candidaters",
        name: "CandidatureOffrePage",
        component: CandidatureOffrePage,
      },
      {
        path: "/offres/:id/avis",
        name: "AvisOffrePage",
        component: AvisOffrePage,
      },


      {
        path: "/ajouter-filiereNiveauMatiere",
        name: "AddFiliereNiveauMatierePage",
        component: AddFiliereNiveauMatierePage,
      },
      {
        path: "/modifier-filiereniveau/:id",
        name: "EditFiliereNiveauMatierePage",
        component: EditFiliereNiveauMatierePage,
      },
      {
        path: "/liste-filiereNiveauMatieres",
        name: "ListeFiliereNiveauMatierePage",
        component: ListeFiliereNiveauMatierePage,
      },

      {
        path: "/liste-qualifications",
        name: "ListeQualificationPage",
        component: ListeQualificationPage,
      },
      {
        path: "/liste-typeEmploiDuTemps",
        name: "ListeTypeEmploiDuTempsPage",
        component: ListeTypeEmploiDuTempsPage,
      },
      {
        path: "/liste-activites",
        name: "ListeActivitePage",
        component: ListeActivitePage,
      },
      {
        path: "/liste-langues",
        name: "ListeLanguePage",
        component: ListeLanguePage,
      },
      {
        path: "/liste-categorieOffres",
        name: "ListeCategorieOffrePage",
        component: ListeCategorieOffrePage,
      },

      {
        path: "/liste-privileges",
        name: "ListePermissionPage",
        component: ListePermissionPage,
      },
      {
        path: "/ajouter-role",
        name: "AddRolePage",
        component: AddRolePage,
      },
      {
        path: "/modifier-role/:id",
        name: "EditRolePage",
        component: EditRolePage,
      },
      {
        path: "/liste-roles",
        name: "ListeRolePage",
        component: ListeRolePage,
      },
      {
        path: "/view-role/:id",
        name: "ViewRolePage",
        component: ViewRolePage,
      },
      {
        path: "/ajouter-user",
        name: "AddUserPage",
        component: AddUserPage,
      },
      {
        path: "/modifier-user/:id",
        name: "EditUserPage",
        component: EditUserPage,
      },
      {
        path: "/liste-users",
        name: "ListeUserPage",
        component: ListeUserPage,
      },
      {
        path: "/profile",
        name: "ProfilePage",
        component: ProfilePage,
      },

      {
        path: "/FaireTest",
        name: "FaireTestPage",
        component: FaireTestPage,
      },
      {
        path: '/liste-sessions',
        name: 'ListeSessionPage',
        component: ListeSessionPage,
      },

      {
        path: '/edit-session/:id',
        name: 'EditSessionPage',
        component: EditSessionPage,
      },
      {
        path: '/view-session/:id',
        name: 'ViewSessionPage',
        component: ViewSessionPage,
      },
      {
        path: '/continuer-session/:id',
        name: 'ContinuerSessionPage',
        component: ContinuerSessionPage,
      },
      {
        path: '/reprendre-session/:id',
        name: 'ReprendreSessionPage',
        component: ReprendreSessionPage,
      },
      {
        path: '/sessions/:id/reponses',
        name: 'ViewSessionReponsePage',
        component: ViewSessionReponsePage,
      },
      {
        path: '/faire-test-qcm',
        name: 'FaireTestQCMPage',
        component: FaireTestQCMPage,
      },
      
      
      
    ],
  },
  {
    path: "/",
    redirect: "/login",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/register",
        name: "RegisterPage",
        component: RegisterPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
      {
        path: "/reset-password",
        name: "ResetPasswordPage",
        component: ResetPasswordPage,
      },
      {
        path: "/email-confirmation",
        name: "EmailConfirmationPage",
        component: EmailConfirmationPage,
      },
      {
        path: "/connected-accounts",
        name: "ConnectedAccountsPage",
        component: ConnectedAccountsPage,
      },
      {
        path: "/maintenance",
        name: "MaintenancePage",
        component: MaintenancePage,
      },
      {
        path: "/logout",
        name: "LogoutPage",
        component: LogoutPage,
      },
    ],
  },
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  // verify auth token before each page change
  //authStore.verifyAuth();

  // before page access check if page requires authentication
  if (to.meta.middleware == "auth") {
    ApiService.setHeader();
    if (authStore.isAuthenticated) {
      next();
    } else {
      next({ name: "LoginPage" });
    }
  } else {
    next();
  }

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});
// window.scrollTo({
//   top: 0,
//   left: 0,
//   behavior: "smooth",
// });

export default router;